import * as Sentry from '@sentry/browser';
import { captureFrontendHttpFailure } from '@tov-plus/observability/sentry/frontend';
import { createOfflineDataCache } from '@tov-plus/pwa';
import { guestEnv } from '../config/env';
import { createGuestApi } from '../lib/api/guestApi';
import { createBrowserHttpClient } from '../lib/http/createBrowserHttpClient';

const httpClient = createBrowserHttpClient({
  baseUrl: guestEnv.apiBaseUrl,
  offlineCacheAdapter: createOfflineDataCache({
    maxEntries: 96,
    maxAgeMs: 7 * 24 * 60 * 60 * 1_000,
  }),
  onError(input) {
    captureFrontendHttpFailure(Sentry, input.error, {
      app: '@tov-plus/guests',
      surface: 'guests',
      method: input.request.method,
      path: input.request.path,
      url: input.url,
      stage: input.stage,
      statusCode: input.statusCode,
      errorCode: input.errorDocument?.error.code ?? null,
      requestId: input.errorDocument?.error.request_id ?? null,
      responseContentType: input.responseContentType,
    });
  },
});

export const guestApi = createGuestApi(httpClient);
